<template>
  <b-modal
    id="contributor-invite-modal"
    ref="deletePocOrInviteModal"
    header-class="anchor-modal"
    :title="modalTitle"
  >
    <p class="mb-2" v-if="this.contributor.role">
      Please, choose if you want to suspend Contributor access to your account or
      completely delete (cannot be undone) the Contributor as a Point of Contact.<br/>
      Contributor Name: <span class="font-weight-bold">{{this.contributor.name}}</span> <br/><br/>
      Remember, the contributor will lose all Anchor Loans access,
      including any access they currently have permissions to.
    </p>
    <p class="mb-2" v-else>
      Are you sure you want to completely delete the Contributor
      as a Point of Contact? <br/>
      Contributor Name: <span class="font-weight-bold">{{this.contributor.name}}</span> <br/>
    </p>
    <div slot="modal-footer" class="w-100 btn-row">
      <b-btn
        class="btn-warning"
        @click="$emit('remove-role')"
        v-show="this.contributor.role"
      >
        Suspend Access
      </b-btn>
      <b-btn class="btn-danger" @click="$emit('delete')">Complete Delete</b-btn>
      <b-btn class="" @click="hide">Cancel</b-btn>
    </div>
  </b-modal>
</template>
<script>
export default {
  data() {
    return {
      contributor: Object,
    };
  },
  computed: {
    modalTitle() {
      if (this.contributor.role) {
        return 'Suspend Access or Delete Contributor';
      }

      return 'Delete Contributor';
    },
  },
  methods: {
    show(contributor) {
      this.contributor = contributor;
      this.$refs.deletePocOrInviteModal.show();
    },
    hide() {
      this.$refs.deletePocOrInviteModal.hide();
    },
  },
};
</script>
<style scoped>
.btn-row {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/tabs/team_members/ContributorDeleteModal.vue